module.exports = __webpack_public_path__ + "static/media/mana.310d6748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/mana.jpg
// module id = 1559
// module chunks = 0